import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './image.css'

const Image = ({className, content}) => {
  const classNames = ['image-content']
  if (className) {
    classNames.push(className)
  }
  const {alt, caption, url} = content

  //Get CDN url somehow
  return (
    <div className={classNames.join(' ')}>
      {
        content.url ?
          <img src={ `${window.CDN_URL}/${url }` } alt={alt} />
          :
          <div className='image-content__no-image-content'>
            <FontAwesomeIcon icon={['fa', 'image']} className='image-content__image-placeholder' />
          </div>
      }
      {
        (caption) ?
          <div className='image-content__caption' dangerouslySetInnerHTML={{__html:caption}} />
          :
          null
      }
    </div>
  )
}

export default Image



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/image/Image.js